__turbopack_context__.v({
  "animate-in-nav-item": "SubNav-module-scss-module__SZObkG__animate-in-nav-item",
  "aspectBox": "SubNav-module-scss-module__SZObkG__aspectBox",
  "buttonCircle": "SubNav-module-scss-module__SZObkG__buttonCircle",
  "fade-in": "SubNav-module-scss-module__SZObkG__fade-in",
  "icon": "SubNav-module-scss-module__SZObkG__icon",
  "isEntered": "SubNav-module-scss-module__SZObkG__isEntered",
  "isExited": "SubNav-module-scss-module__SZObkG__isExited",
  "isExiting": "SubNav-module-scss-module__SZObkG__isExiting",
  "isVisible": "SubNav-module-scss-module__SZObkG__isVisible",
  "item": "SubNav-module-scss-module__SZObkG__item",
  "itemActive": "SubNav-module-scss-module__SZObkG__itemActive",
  "label": "SubNav-module-scss-module__SZObkG__label",
  "menu": "SubNav-module-scss-module__SZObkG__menu",
  "menuCurrentTitle": "SubNav-module-scss-module__SZObkG__menuCurrentTitle",
  "menuCurrentTitleSeparator": "SubNav-module-scss-module__SZObkG__menuCurrentTitleSeparator",
  "menuTitle": "SubNav-module-scss-module__SZObkG__menuTitle",
  "menuTrigger": "SubNav-module-scss-module__SZObkG__menuTrigger",
  "root": "SubNav-module-scss-module__SZObkG__root",
  "rootInner": "SubNav-module-scss-module__SZObkG__rootInner",
});
